var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_847_2009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.5C6.03639 7.52477 5.16697 8.89771 4.75943 10.4329C4.35189 11.9682 4.42592 13.5915 4.9715 15.0833C5.51708 16.5751 6.50786 17.8632 7.80971 18.7732C9.11156 19.6833 10.6616 20.1714 12.25 20.1714C13.8384 20.1714 15.3884 19.6833 16.6903 18.7732C17.9921 17.8632 18.9829 16.5751 19.5285 15.0833C20.0741 13.5915 20.1481 11.9682 19.7406 10.4329C19.333 8.89771 18.4636 7.52477 17.25 6.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.5V12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_847_2009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.14df5a1cba6850f8e19565df136e316a.svg";
export { ForwardRef as ReactComponent };